import React from 'react';
import { SearchParameter, SearchProps } from './types';
import { Search as JuicySearch } from '@vtbhome/juicyfront';
import { debounce } from '@shared/lib/utils/debounce/debounce';

export const Search: React.FC<SearchProps> = ({
    placeholder,
    sortParametersAfterClearSearch,
    disabled,
    parameters,
    setParameters,
}) => {
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target as HTMLInputElement | null;
        if (!input || !setParameters) {
            return;
        }
        const search = input.value;
        let sortParameters: SearchParameter = {};

        if (search && !parameters?.search) {
            // // Очистка сортировки при наличии поиска, иначе элементы выводятся в некорректной последовательности
            sortParameters = { sort: null, order: null };
        } else if (!search && parameters?.search) {
            // // Очистка сортировки после очистки поиска
            if (sortParametersAfterClearSearch) {
                sortParameters = sortParametersAfterClearSearch;
            } else {
                sortParameters = { sort: null, order: null };
            }
        }

        if (parameters && Object.keys(parameters).includes('skip') && parameters?.skip !== null) {
            setParameters({ ...parameters, skip: null, search, ...sortParameters });
        } else {
            setParameters({ ...parameters, search, ...sortParameters });
        }
    };

    const handleResetSearch = () => {
        if (!setParameters) {
            return;
        }
        setParameters({ ...parameters, search: '', ...(sortParametersAfterClearSearch || {}) });
    };

    const handleSearchDebounce = debounce(handleSearch, 300);

    return (
        <JuicySearch
            placeholder={placeholder}
            disabled={disabled}
            value={parameters?.search || ''}
            onChange={handleSearchDebounce}
            onClear={handleResetSearch}
        />
    );
};
